import React, { useState } from "react"
import ReceiptViewHeader from "./ReceiptViewHeader"
import ReceiptDropzoneButton from "./ReceiptDropzoneButton"

const UploadView = ({canContinue, headline, introCopy, onUploadNext, handleImageUpload, setUploadErrors, handleError=()=>{}, uploadInProgress, children}) => {
  
  
  return (
    <div className="receipt-view upload-view">
      <ReceiptViewHeader headline={headline} introCopy={introCopy} />
      <div className={`receipt-view-content`}>
        {/* image list is passed in as children */}
       {children}
       {canContinue === false && (<p className="error">Please submit at least one receipt image to continue.</p>)}
      </div>
      <div className={`receipt-button-container`}>
        <ReceiptDropzoneButton setUploadErrors={setUploadErrors} onUpload={handleImageUpload} onError={handleError} className="btn themed-button-secondary" label="Upload more images" disabled={uploadInProgress} />
        <button className="btn themed-button" onClick={()=>{onUploadNext && onUploadNext()}} disabled={uploadInProgress || canContinue !== true}>Next</button>
      </div>
    </div>
  )
}
export default UploadView
